import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "2 quick tips for 250% better Lighthouse scores – CodeWithSwiz 28",
  "description": "Your site may be fast for users, but Google don't care. Official metrics or bust.",
  "published": "2021-04-27T00:00:00.000Z",
  "categories": "CodeWithSwiz, Frontend, Performance, Lighthouse",
  "hero": "./img/screenshot-1619540630598.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Your site may be fast for users, but Google don't care. Official metrics or bust.`}</p>
    <p><em parentName="p">{`CodeWithSwiz is a weekly live show. Like a podcast with video and fun hacking. Focused on experiments and open source. `}<a parentName="em" {...{
          "href": "https://youtube.com/swizecteller"
        }}>{`Join live Tuesday mornings`}</a></em></p>
    <lite-youtube {...{
      "videoid": "xl9yyWh8Sj4",
      "videostartat": "0"
    }}></lite-youtube>
    <p>{`When you go to `}<a parentName="p" {...{
        "href": "https://serverlesshandbook.dev"
      }}>{`ServerlessHandbook.dev`}</a>{` it feels fast. Even with a cold cache.`}</p>
    <p><img parentName="p" {...{
        "src": "/9e4ae10bb605a337ba98e7fd37a68249/Serverless-Handbook-page-load-for-users772ai3.gif",
        "alt": "Serverless Handbook page load for users"
      }}></img></p>
    <p>{`Vercel's edge network loads HTML fast, the CDN loads assets quickly, and Gatsby is great at quick renders and hydration. Static site – optimized for speed – turns into a React webapp optimized for interaction. Wonderful 👌`}</p>
    <h2 {...{
      "id": "the-problem"
    }}>{`The problem`}</h2>
    <p>{`Your `}<a parentName="p" {...{
        "href": "https://web.dev/measure/"
      }}>{`lighthouse scores`}</a>{` tell a different story – the story that matters to Google and SEO.`}</p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "890px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/1d0c0ecfc62bb77254d5dbecefe0ad1d/555cf/Bad-lighthouse-scoree59631.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "60.53811659192825%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'243\\'%20viewBox=\\'0%200%20400%20243\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M348%205v12l1%2011h22l24-1c1-1%202-20%201-22-2-2-47-1-48%200M94%2014l-11%201a216%20216%200%2000-20%201l-18-1H34l-2%201v4l1-2%201%201h1c0-2%202-3%202-1l8-1%202%201h7c0-2%200-2%201-1l5%201h1c1%201%207%201%208-1h1c1%202%206%202%206%200h1c1%202%2020%202%2020%200s-3-4-3-3M12%2069c0%203%200%203%202%202h2l2%201%201-1h1c0%202%202%201%202-1h1c0%202%207%202%208%200h1l1%202%201-2%201%201%201%202v-2l1-1c0%202%201%202%203%202%203%200%204-1%204-2h1c0%202%202%203%203%201l2-2c2%200%201%202-1%202-1%201%200%201%202%201l4-2-15-1c-11%200-15-1-15-2s-1-1-3%201c-2%201-3%201-6-1-4-1-4-2-4%202m123-1l-2%202v-1l-5-1c-5%200-8%203-4%204l2-1%201-1%201%201%209%201c8%200%2010-1%2010-2h1v3c-1%202%201%201%203-2v-3l-1%201h-2c-1-1-2-2-3-1l-2-1h-3c-1%202-1%202-2%201-2-2-2-2-3%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/1d0c0ecfc62bb77254d5dbecefe0ad1d/ca0a1/Bad-lighthouse-scoree59631.webp 223w", "/static/1d0c0ecfc62bb77254d5dbecefe0ad1d/75680/Bad-lighthouse-scoree59631.webp 445w", "/static/1d0c0ecfc62bb77254d5dbecefe0ad1d/8d1ba/Bad-lighthouse-scoree59631.webp 890w", "/static/1d0c0ecfc62bb77254d5dbecefe0ad1d/3838e/Bad-lighthouse-scoree59631.webp 1335w", "/static/1d0c0ecfc62bb77254d5dbecefe0ad1d/e11e5/Bad-lighthouse-scoree59631.webp 1780w", "/static/1d0c0ecfc62bb77254d5dbecefe0ad1d/9ddbc/Bad-lighthouse-scoree59631.webp 1960w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/1d0c0ecfc62bb77254d5dbecefe0ad1d/e92b6/Bad-lighthouse-scoree59631.png 223w", "/static/1d0c0ecfc62bb77254d5dbecefe0ad1d/e66bf/Bad-lighthouse-scoree59631.png 445w", "/static/1d0c0ecfc62bb77254d5dbecefe0ad1d/4ef49/Bad-lighthouse-scoree59631.png 890w", "/static/1d0c0ecfc62bb77254d5dbecefe0ad1d/4e814/Bad-lighthouse-scoree59631.png 1335w", "/static/1d0c0ecfc62bb77254d5dbecefe0ad1d/701e9/Bad-lighthouse-scoree59631.png 1780w", "/static/1d0c0ecfc62bb77254d5dbecefe0ad1d/555cf/Bad-lighthouse-scoree59631.png 1960w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/1d0c0ecfc62bb77254d5dbecefe0ad1d/4ef49/Bad-lighthouse-scoree59631.png",
                "alt": "Bad lighthouse score",
                "title": "Bad lighthouse score",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`Bad lighthouse score`}</figcaption>{`
  `}</figure></p>
    <p>{`16 sucks for a performance score. Google has been hammering down on slow sites and that means you have to care.`}</p>
    <p>{`You and I know the page doesn't take 90 seconds to become interactive and Google don't care. If they can't measure it, they can't see it.`}</p>
    <h2 {...{
      "id": "250-improvement-with-a-bit-of-fiddling"
    }}>{`250% improvement with a bit of fiddling`}</h2>
    <p>{`An hour of fiddling gave us a 250% boost in measured performance. 🤘`}</p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "890px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/490ad79f4751dc2aa9e34988ef7c52de/e53e8/250percent-better-measurable-performance828968.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "60.53811659192825%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'243\\'%20viewBox=\\'0%200%20400%20243\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M348%206l-1%2011v11h48V18l-1-12c-1-1-45-2-46%200M69%2016c0%202%200%202-1%201l-5-1H36l-2%201v4l1-1h2l1-2%201%201%207-1c1-1%201-1%202%201h3c2%201%203%201%204-1h2c0%202%203%202%205%201h1c0%201%206%201%207-1h1c2%202%2025%202%2027%201%201-2-1-4-3-3H79l-8-1c-2-1-2-1-2%201m302%2046c-6%207-2%2017%208%2017%204%200%208-5%208-10%200-8-10-12-16-7m3%200c-5%202-6%2012%200%2015%204%202%206%201%209-2%207-7%200-16-9-13M14%2070c0%202%200%202%202%201l3%201c1%201%205%200%205-2h1l1%202h6l1-1%201-1%201%201v1l1-2%201%201%201%202v-2l1-1c0%203%207%203%207%200h1l1%202h8c1-3%200-3-13-4l-15%201h-1c0-1%200-2-1-1h-8l-2-1c-1%200-2%201-2%203m98-1c-2%203-3%203%2020%203l16-1c1-2%201-1%201%201s0%202%202%201l1-4h-2l-9-1h-2c-3-2-4-1-4%201s0%202-1%201c0-2-1-2-3-1h-1l-8-1h-8c0-2-2-1-2%201m113-1v4l2-1h2c0%201%201%201%202-1h1c-1%202%201%204%202%202h4v-1l-1-1%202-1%201%202c0%201%206%202%207%201h4c0-2%202-3%202-1l1%201%201-2c0-2%200-2-5-2-4%200-5%201-4%202v1l-2-2c-1-1-2-2-3-1h-16M92%20107l-37%204a698%20698%200%200037-4\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/490ad79f4751dc2aa9e34988ef7c52de/ca0a1/250percent-better-measurable-performance828968.webp 223w", "/static/490ad79f4751dc2aa9e34988ef7c52de/75680/250percent-better-measurable-performance828968.webp 445w", "/static/490ad79f4751dc2aa9e34988ef7c52de/8d1ba/250percent-better-measurable-performance828968.webp 890w", "/static/490ad79f4751dc2aa9e34988ef7c52de/3838e/250percent-better-measurable-performance828968.webp 1335w", "/static/490ad79f4751dc2aa9e34988ef7c52de/e11e5/250percent-better-measurable-performance828968.webp 1780w", "/static/490ad79f4751dc2aa9e34988ef7c52de/79c50/250percent-better-measurable-performance828968.webp 1982w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/490ad79f4751dc2aa9e34988ef7c52de/e92b6/250percent-better-measurable-performance828968.png 223w", "/static/490ad79f4751dc2aa9e34988ef7c52de/e66bf/250percent-better-measurable-performance828968.png 445w", "/static/490ad79f4751dc2aa9e34988ef7c52de/4ef49/250percent-better-measurable-performance828968.png 890w", "/static/490ad79f4751dc2aa9e34988ef7c52de/4e814/250percent-better-measurable-performance828968.png 1335w", "/static/490ad79f4751dc2aa9e34988ef7c52de/701e9/250percent-better-measurable-performance828968.png 1780w", "/static/490ad79f4751dc2aa9e34988ef7c52de/e53e8/250percent-better-measurable-performance828968.png 1982w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/490ad79f4751dc2aa9e34988ef7c52de/4ef49/250percent-better-measurable-performance828968.png",
                "alt": "250% better measurable performance",
                "title": "250% better measurable performance",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`250% better measurable performance`}</figcaption>{`
  `}</figure></p>
    <p>{`Plenty of room for improvement, but 40 is much better than 16. Although time-to-interactive became worse 🤨`}</p>
    <p>{`There must be a bug with how Lighthouse measures Gatsby sites, surely?`}</p>
    <h2 {...{
      "id": "fix-1-kill-youtube-embeds"
    }}>{`Fix 1: Kill Youtube embeds`}</h2>
    <p>{`Despite Google's waxing poetic about web performance and how your site must be fast in the remotest of African villages, they're the worst code you can put on your site.`}</p>
    <p>{`Check this out:`}</p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "890px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/3c8d682962e45451c413c903b08d2636/b6e50/Youtube-is-the-worst-offenderj53fic.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "52.466367713004495%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'210\\'%20viewBox=\\'0%200%20400%20210\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M89%203v2l-1%201-1-1H76c-1-2-1-2-1%200l-1%202h-1l4%201%203-1h4l4%201c3%200%203%200%202-1V6h3c1-1%201-1%202%201h2c0-2%200-2%201%200s1%202%203%201h3l1-3c0-2%200-2-5-1a89%2089%200%2000-9%200V3h-2m134%203l65%201a814%20814%200%20000-2l-65%201M75%2032c0%201%200%202-1%201l-1%201c1%202%206%202%207%200h4l6%201c7%200%207%200%207-2l1%201c1%202%202%202%203%202l3-1%201-2c0-2-1-2-3-2h-4l-5%201c-3%200-4%200-3-1v-1c-2%200-3%203-1%203v1l-2-1c-1-2-10-2-10-1h-1c-1-2-1-2-1%200m111-1h-6l-6%201-3%201-8-2c-6%200-6%201-6%202%200%202%200%202%203%202l5-1h1c2%202%2011%201%2012%200h1c0%201%203%202%204%201h1c1%201%204%200%204-2s-2-3-2-2m63%202v3h18c16%200%2017%200%2017-2s-1-3-3-2h-1l-6-1c-4%200-5%200-5%202l-1%202-2-1c0-2%200-3-2-3l-3%201h-1c-3-1-6-1-7%201s-1%202-2%200c-1-4-2-4-2%200m-59%2016l-1%202c-3%201%200%202%205%202%204%201%205%201%205-1-1-1-1-1%200%200l13%201h16c2%201%202%201%203-1s1-2%201%200l6%201c8%200%208%200%208-2s-1-2-4-2l-5-1-2%201h-2c-1-1-5%200-5%202h-1l-3-3c-2-1-2-1-2%202l-1%202-1-2c0-1-1-2-7-1l-7-1c0-2-3-1-3%201l1%201%201%201c0%202-2%201-3-1s-1-2-3-1h-4c-2-1-2-1-3%201l-1-1c-1-2-1-2-1%200m118-1c-3%202%201%206%203%204h11c2-2%203-2%203-1s2%202%206%202c6%200%207-1%207-2%200-2-1-2-10-2l-11-1h-9M72%2061c0%202%203%203%203%200h1c0%202%204%203%204%201h5l2-1v2l2%201%204-1%204-2c1-1%201-1%201%201v2l1-2c1-2%201-2%201%200s0%202%202%201v-3l-2-1c-2-1-7%200-8%201h-4l-3-1h-7l-1%201c-3-2-5-2-5%201m79%200v3h32l33-1c1-2-1-4-3-4-10%200-13%200-14%202h-2l1-1v-1l-3%201-1%201v-1c1-1-1-1-5-1s-6%201-7%202h-2l-4-1-3-1h-14l-2%201h-1l-2-1h-2c-1-1-1%200-1%202M42%20121c0%202%203%204%204%202h1l2%201v-2l-2-2%202%202%204%201h15c1-2-1-4-3-3h-1l-3-1-3%201-2-1h-4l-1%201c0-3-6-2-6%200-1%202-1%202-1%200%200-3-2-3-2%201m-11%2017v4l1-1h2c1%200%202%200%203-2h1c0%201%201%202%206%201l6%201h9c5%200%206-1%205-2l-3-3-1%201h-7l-5-1H38c-1-1-1-1-2%201%200%202%200%202-2%200h-1l-1-1-1%202m35%200c-1%201-1%201%201%202%203%201%208%201%208-1h1c1%202%205%202%205%200l1%201%201%202v-2c0-2%200-2%201-1%201%202%206%202%207%200h1c0%202%204%202%204%201v-2c0-2-27-2-30%200m-42%2016l1%203h1c0%202%204%201%205-1%201-1%201-1%201%201v2l1-2%201-1c0%202%2012%203%2014%201h1c0%202%206%201%207-1h1c0%202%201%202%206%202l6-1a413%20413%200%2001-2-3H24m111%2016v1l1%202c0%202%200%202%201%200s1-2%201%200%203%203%203%200l1%201%201%202v-2c0-2%200-2%201-1%201%203%2010%203%2010%200h1c1%203%2024%202%2025%200h1c0%202%2010%203%2010%201h1c1%202%209%201%209-1h1c0%202%201%202%204%202%202%200%203%200%202-1l-1-2c0-1%200-2-1-1a69%2069%200%2001-22%200h-5l-5%201h-2c-4-2-8-2-8%200l-1%202-1-2-1-2-1%201h-10l-11-1h-4m-111%202c-1%203%200%204%201%202h1c0%202%205%201%205-1l1%201%201%202v-2l1-1c0%203%2021%203%2022%200h1c0%202%2011%203%2013%201%201-2-1-4-3-3h-4a155%20155%200%2000-26%200H27c-2-1-2-1-3%201m60-1h-7c-6%200-7%200-5%203h3c0%202%204%201%205-1h1c0%202%2011%203%2011%200h1c0%202%2011%202%2012%200h1c0%203%2020%203%2020%200h1c1%203%205%202%205%200s0-3-1-2a68%2068%200%2001-22%200h-5l-5%201h-2l-7-1h-6\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/3c8d682962e45451c413c903b08d2636/ca0a1/Youtube-is-the-worst-offenderj53fic.webp 223w", "/static/3c8d682962e45451c413c903b08d2636/75680/Youtube-is-the-worst-offenderj53fic.webp 445w", "/static/3c8d682962e45451c413c903b08d2636/8d1ba/Youtube-is-the-worst-offenderj53fic.webp 890w", "/static/3c8d682962e45451c413c903b08d2636/3838e/Youtube-is-the-worst-offenderj53fic.webp 1335w", "/static/3c8d682962e45451c413c903b08d2636/e11e5/Youtube-is-the-worst-offenderj53fic.webp 1780w", "/static/3c8d682962e45451c413c903b08d2636/511b7/Youtube-is-the-worst-offenderj53fic.webp 1862w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/3c8d682962e45451c413c903b08d2636/e92b6/Youtube-is-the-worst-offenderj53fic.png 223w", "/static/3c8d682962e45451c413c903b08d2636/e66bf/Youtube-is-the-worst-offenderj53fic.png 445w", "/static/3c8d682962e45451c413c903b08d2636/4ef49/Youtube-is-the-worst-offenderj53fic.png 890w", "/static/3c8d682962e45451c413c903b08d2636/4e814/Youtube-is-the-worst-offenderj53fic.png 1335w", "/static/3c8d682962e45451c413c903b08d2636/701e9/Youtube-is-the-worst-offenderj53fic.png 1780w", "/static/3c8d682962e45451c413c903b08d2636/b6e50/Youtube-is-the-worst-offenderj53fic.png 1862w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/3c8d682962e45451c413c903b08d2636/4ef49/Youtube-is-the-worst-offenderj53fic.png",
                "alt": "Youtube is the worst offender",
                "title": "Youtube is the worst offender",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`Youtube is the worst offender`}</figcaption>{`
  `}</figure></p>
    <p><em parentName="p">{`"Oh hey you have unused JavaScript and maybe you don't know how to write decent code. Here are the files you should look at`}</em></p>
    <ul>
      <li parentName="ul">{`youtube`}</li>
      <li parentName="ul">{`gumroad`}</li>
      <li parentName="ul">{`twitter`}</li>
    </ul>
    <p>{`Right.`}</p>
    <p>{`You `}<em parentName="p">{`can`}</em>{` remove Youtube from your site `}<em parentName="p">{`and`}</em>{` keep Youtube embeds. Using a facade.`}</p>
    <p><a parentName="p" {...{
        "href": "https://web.dev/third-party-facades/"
      }}>{`Facades`}</a>{` let you load 3rd-party resources by showing a static preview first. When the user interacts, it turns into a full embed.`}</p>
    <p>{`The `}<a parentName="p" {...{
        "href": "https://github.com/justinribeiro/lite-youtube"
      }}>{`lite-youtube`}</a>{` plugin by @justinribeiro implements this pattern as a web component.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`// import anywhere globally
// gatsby-browser.js for me
import "@justinribeiro/lite-youtube"
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<!-- use in a page -->
<lite-youtube videoid="udqyBqCgLrU" autoload></lite-youtube>
`}</code></pre>
    <p>{`You get a native-looking Youtube embed with perfect lighthouse scores.`}</p>
    <p><img parentName="p" {...{
        "src": "/718690a6816cb3a593e83294bd2ea2af/Autoloading-Youtube-facade66553a.gif",
        "alt": "Autoloading Youtube facade"
      }}></img></p>
    <h2 {...{
      "id": "fix-2-kill-big-images"
    }}>{`Fix 2: Kill big images`}</h2>
    <p>{`Gatsby and NextJS come with optimized image components these days. You render an image, transform into fancy formats on deploy, and make your site fast.`}</p>
    <p>{`I forgot to use that for the cover image. Loaded 6MB of data 💩`}</p>
    <p>{`Like this:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`import coverImg from "../images/cover.png"

// ...
;<img src={coverImg} />
`}</code></pre>
    <p>{`That works `}{`[name|]`}{`. You can import images like they're code in every modern JavaScript environment.`}</p>
    <p>{`And it leads to terrible performance.`}</p>
    <p>{`Here's what you can do since Gatsby v3 – a new image component with a fantastic API.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`import { StaticImage } from "gatsby-plugin-image"

// ...
;<StaticImage
  src="../images/cover.png"
  alt="Serverless Handbook cover"
  loading="eager"
  objectFit="cover"
/>
`}</code></pre>
    <p><inlineCode parentName="p">{`StaticImage`}</inlineCode>{` loads your image at build-time, optimizes into different formats, resizes to fit your container, and handles rendering in the browser.`}</p>
    <p>{`The final result is an `}<inlineCode parentName="p">{`<img>`}</inlineCode>{` tag like this:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<img
  data-gatsby-image-ssr=""
  data-main-image=""
  style="object-fit: cover; object-position: 50 50; opacity: 1;"
  sizes="(min-width: 1877px) 1877px, 100vw"
  decoding="async"
  loading="eager"
  src="/static/12464dcff493620208d29a0abec73bb7/69e59/cover.png"
  srcset="
    /static/12464dcff493620208d29a0abec73bb7/a16c8/cover.png  469w,
    /static/12464dcff493620208d29a0abec73bb7/56dcd/cover.png  939w,
    /static/12464dcff493620208d29a0abec73bb7/69e59/cover.png 1877w
  "
  alt="Serverless Handbook cover"
/>
`}</code></pre>
    <p>{`Notice how many different sizes there are. That's so your phone loads the 469px image and your computer loads 1877px. Huge difference in file size.`}</p>
    <p><inlineCode parentName="p">{`eager`}</inlineCode>{` and `}<inlineCode parentName="p">{`lazy`}</inlineCode>{` loading supported out of the box 🤘`}</p>
    <p>{`If you need dynamic images, you'll have to reach for the `}<inlineCode parentName="p">{`<GatsbyImage>`}</inlineCode>{` component and fiddle with GraphQL. You can read more about Gatsby's new `}<a parentName="p" {...{
        "href": "https://www.gatsbyjs.com/docs/reference/built-in-components/gatsby-plugin-image"
      }}>{`gatsby-plugin-image`}</a>{` on their docs.`}</p>
    <h2 {...{
      "id": "tips-for-running-lighthouse"
    }}>{`Tips for running Lighthouse`}</h2>
    <p>{`Lighthouse can be fiddly.`}</p>
    <ol>
      <li parentName="ol">{`Official score on `}<a parentName="li" {...{
          "href": "https://web.dev/measure"
        }}>{`web.dev/measure`}</a></li>
      <li parentName="ol">{`Dev score in Chrome devtools`}</li>
      <li parentName="ol">{`Ignore your JavaScript sizes when using localhost (they're unoptimized)`}</li>
      <li parentName="ol">{`Use incognito, browser extensions may impact your score`}</li>
    </ol>
    <p>{`And if you know of a facade for Twitter embeds please let me know. That's the next area I gotta fix`}</p>
    <p>{`Cheers,`}<br />{`
~Swizec`}</p>
    <p>{`PS: there's a Gatsby plugin I can't wait to try called `}<a parentName="p" {...{
        "href": "https://www.gatsbyjs.com/plugins/gatsby-remark-embed-video-lite/"
      }}>{`gatsby-remark-video-embed-lite`}</a>{` which will turn `}<em parentName="p">{`every video on all my sites into a facade`}</em>{` 😍`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      